import React from "react";
import "./Download_Btn.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload } from "@fortawesome/free-solid-svg-icons";

const Download_Btn = ({ text = "Download Brochure", onClick, ...props }) => {
  return (
    <button
      variant="outline-primary"
      className="download_btn_custom"
      onClick={onClick}
      {...props}
    >
      {/* Icon Animation Wrapper */}
      <span className="icon_slide_container">
        <FontAwesomeIcon
          icon={faDownload}
          style={{ color: "#093D5D" }}
          className="slide_icon icon_initial"
        />
        <FontAwesomeIcon
          icon={faDownload}
          style={{ color: "#fff" }}
          className="slide_icon icon_hover"
        />
      </span>

      {/* Static Text */}
      <span className="btn-text-static">{text}</span>
    </button>
  );
};

export default Download_Btn;
